import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/Footer.scss'
import logo from '../assets/icons/logo-white.svg';
import facebook from '../assets/icons/ic-facebook.svg';
import linkedin from '../assets/icons/ic-linkedin.svg';
import twitter from '../assets/icons/ic-twitter.svg';
import youtube from '../assets/icons/youtube-symbol.svg';

class Footer extends React.Component {
    componentDidMount() {

    }

    render() {
        return (
            <footer id="footer">
                <div className="footer-container">
                    <div className="footer-header">
                        <Link to="/" className="footer-title"><img src={logo} alt="logo"/></Link>
                        <div className="social-icons">
                            <a href=" https://www.facebook.com/lawshram" target="_blank" rel="noopener noreferrer"><img
                                src={facebook} alt="facebook"/></a>
                            <a href="https://www.linkedin.com/company/lawshram" target="_blank"
                               rel="noopener noreferrer"><img src={linkedin} alt="linkedin"/></a>
                            <a href="https://twitter.com/lawshram" target="_blank" rel="noopener noreferrer"><img
                                src={twitter} alt="twitter"/></a>
                            <span><img src={youtube} alt="youtube"/></span>
                        </div>
                        <div className="tab-links">
                            <Link to="/contact-us" className="connect-us">Connect with Us</Link>
                            <Link to="/about" className="about-us">About US </Link>
                        </div>
                    </div>
                    <div className="disclaimer-wrapper">
                        <p className="disclaimer">Disclaimer</p>
                        <p className="disclaimer-content">Lawshram is a NOT a law firm. Lawshram aims to serve as a
                            platform
                            facilitating lawyers to exchange knowledge and practise law.
                        </p>
                    </div>
                </div>

            </footer>
        )
    }
}

export default Footer;